import { Check } from '#components/Check'
import { GrayBox } from '#components/GrayBox'
import { usePop } from '#hooks'
import { Notice, PanelBody, Spinner } from '@wordpress/components'
import { useTranslation } from 'react-i18next'

const htmlWordCounter = (html) => {
  const parser = new DOMParser()
  const rendered = parser.parseFromString(html, 'text/html')

  return rendered.documentElement.textContent
    .replace(/(\r\n|\n|\r)/gm, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ').length
}

export const EnoughWords = ({ pop }) => {
  const { t } = useTranslation()

  const WORDS = 300
  const { post, isError, isLoading, isValidating } = usePop(pop)

  if (isError) {
    return <Notice status="error">{isError}</Notice>
  }

  if (isLoading) {
    return <Spinner />
  }

  if (!post) {
    return null
  }

  const wordsCount =
    htmlWordCounter(post.title.rendered) +
    htmlWordCounter(post.content.rendered)

  return (
    <PanelBody
      title={t('sidebar.enoughwords.title')}
      icon={
        isValidating ? <Spinner /> : <Check condition={wordsCount >= WORDS} />
      }
      initialOpen={wordsCount < WORDS}
    >
      <p>{t('sidebar.enoughwords.intro.1', { count: WORDS })}</p>
      <p>{t('sidebar.enoughwords.intro.2', { count: wordsCount })}</p>
      <GrayBox condition={wordsCount >= WORDS}>
        {t('sidebar.enoughwords.counter', { count: wordsCount })}
      </GrayBox>
    </PanelBody>
  )
}
